<div class="ontario-row">
  <div class="ontario-columns">
    <h2 id="pageTitle">{{ 'bss.admin.selectUserAcc.title' | translate }}</h2>
    <hr style="margin-top: 0px; margin-bottom: 0px;">
  </div>
</div>

<div *ngIf="appError && !appSuccess" class="ontario-row" aria-live="polite" aria-atomic="true" id="pageLevelMessageId" #pageMsg>
  <div class="ontario-columns">
    <div class="ontario-alert ontario-alert--error ">
      <div class="ontario-alert__header">
        <div class="ontario-alert__header-icon">
          <svg class="ontario-icon" alt="Error" aria-hidden="true" focusable="false" sol:category="primary"
            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
            <use href="#ontario-icon-alert-error"></use>
          </svg>
        </div>
        <h2 class="ontario-alert__header-title ontario-h4">{{'bss.error' | translate}}</h2>
      </div>
      <div class="ontario-alert__body">
        <p [innerHTML]="appErrorMessage | translate"></p>
      </div>
    </div>
  </div>
</div>

<div class="ontario-row">
  <div class="ontario-columns">
    <div class="ontario-table-container ontario-small-12 ontario-medium-12 ontario-large-12">
      <div class="ontario-table-scroll--wrapper">
        <div class="ontario-table-scroll--div" style="visibility: visible; height: 20px; width: 537px;"></div>
      </div>
      <div *ngIf="userDetailsPage" class="ontario-table-div" style="display: inline-block;">
        <table tabindex="101">
          <caption>{{'bss.admin.selectUserAcc.selectRole'|translate}} {{roleName}} </caption>
          <thead>
            <tr>
              <th scope="col">
                <a href="#" tabindex="102" (click)="onSort($event, 'firstName')" 
                  [title]="(getSortOrder('firstName')) === 'desc' ? 
                          ('bss.admin.selectUserAcc.sortBy' | translate) + ' ' + ('bss.admin.selectUserAcc.firstName' | translate) + ' ' + ('bss.admin.selectUserAcc.sortByDesc' | translate) : 
                          ('bss.admin.selectUserAcc.sortBy' | translate) + ' ' + ('bss.admin.selectUserAcc.firstName' | translate) + ' ' + ('bss.admin.selectUserAcc.sortByAsc' | translate)" >
                  {{ 'bss.admin.selectUserAcc.firstName' | translate }}
                </a>
              </th>
              <th scope="col">
                <a href="#" tabindex="103" (click)="onSort($event, 'lastName')" 
                  [title]="(getSortOrder('lastName')) === 'desc' ? 
                          ('bss.admin.selectUserAcc.sortBy' | translate) + ' ' + ('bss.admin.selectUserAcc.lastName' | translate) + ' ' + ('bss.admin.selectUserAcc.sortByDesc' | translate) : 
                          ('bss.admin.selectUserAcc.sortBy' | translate) + ' ' + ('bss.admin.selectUserAcc.lastName' | translate) + ' ' + ('bss.admin.selectUserAcc.sortByAsc' | translate)" >
                  {{ 'bss.admin.selectUserAcc.lastName' | translate }}
                </a>
              </th>
              <th scope="col">
                <a href="#" tabindex="104" (click)="onSort($event, 'email')" 
                  [title]="(getSortOrder('email')) === 'desc' ? 
                          ('bss.admin.selectUserAcc.sortBy' | translate) + ' ' + ('bss.admin.selectUserAcc.emailAdd' | translate) + ' ' + ('bss.admin.selectUserAcc.sortByDesc' | translate) : 
                          ('bss.admin.selectUserAcc.sortBy' | translate) + ' ' + ('bss.admin.selectUserAcc.emailAdd' | translate) + ' ' + ('bss.admin.selectUserAcc.sortByAsc' | translate)" >
                  {{ 'bss.admin.selectUserAcc.emailAdd' | translate }}
                </a>                
              </th>
              <th scope="col">
                <a href="#" tabindex="105" (click)="onSort($event, 'roleStatus')" 
                  [title]="(getSortOrder('roleStatus')) === 'desc' ? 
                          ('bss.admin.selectUserAcc.sortBy' | translate) + ' ' + ('bss.admin.selectUserAcc.role' | translate) + ' ' + ('bss.admin.selectUserAcc.sortByDesc' | translate) : 
                          ('bss.admin.selectUserAcc.sortBy' | translate) + ' ' + ('bss.admin.selectUserAcc.role' | translate) + ' ' + ('bss.admin.selectUserAcc.sortByAsc' | translate)" >
                  {{ 'bss.admin.selectUserAcc.role' | translate }}
                </a>
              </th>
              <th scope="col">
                <a href="#" tabindex="106" (click)="onSort($event, 'accountStatus')" 
                  [title]="(getSortOrder('accountStatus')) === 'desc' ? 
                          ('bss.admin.selectUserAcc.sortBy' | translate) + ' ' + ('bss.admin.selectUserAcc.status' | translate) + ' ' + ('bss.admin.selectUserAcc.sortByDesc' | translate) : 
                          ('bss.admin.selectUserAcc.sortBy' | translate) + ' ' + ('bss.admin.selectUserAcc.status' | translate) + ' ' + ('bss.admin.selectUserAcc.sortByAsc' | translate)" >
                  {{ 'bss.admin.selectUserAcc.status' | translate }}
                </a>                
              </th>
              <th scope="col">
                {{ 'bss.admin.selectUserAcc.select' | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of userDetailsPage; let i = index">
              <td>
                {{user.firstName}}
              </td>
              <td>
                {{user.lastName}}
              </td>
              <td>
                {{user.email}}
              </td>
              <td>
                <span *ngIf="user.roleStatus === '0'">{{ 'bss.admin.selectUserAcc.role.notAssigned' | translate }}</span>
                <span *ngIf="user.roleStatus === '1'">{{ 'bss.admin.selectUserAcc.role.assigned' | translate }}</span>
              </td>
              <td>
                <span *ngIf="user.accountStatus === '0'">{{ 'bss.admin.selectUserAcc.status.active' | translate }}</span>
                <span *ngIf="user.accountStatus === '1'">{{ 'bss.admin.selectUserAcc.status.locked' | translate }}</span>
                <span *ngIf="user.accountStatus === '2'">{{ 'bss.admin.selectUserAcc.status.expired' | translate }}</span>
                <span *ngIf="user.accountStatus === '3'">{{ 'bss.admin.selectUserAcc.status.disabled' | translate }}</span>
                <span *ngIf="user.accountStatus === '4'">{{ 'bss.admin.selectUserAcc.status.activeLocked' | translate }}</span>
                <span *ngIf="user.accountStatus !== '0' && user.accountStatus !== '1' && user.accountStatus !== '2' && user.accountStatus !== '3' && user.accountStatus !== '4'">{{user.accountStatus}}</span>
              </td>
              <td>
                <input [tabindex]="110 + i" [id]="'user' + i" name="selectUser" type="radio" [value]="user.email"
                  [checked]="selectedUserEmail === user.email" (change)="onUserSelected(user)"
                  title="{{'bss.admin.selectUserAcc.select.title'|translate}}">
              </td>
            </tr>
          </tbody>
        </table>

        <div *ngIf="totalPage > 1" style="font-size: 1.2rem; width: 100%; text-align: right; margin-top: 25px">
            {{ 'bss.admin.selectUserAcc.page' | translate }} 
            <ng-container *ngFor="let pageNumber of getPageNumbers(); let i = index; let last = last">
              <span *ngIf="currentPage === pageNumber; else pageLink">{{ pageNumber }}</span>
              <ng-template #pageLink>
                <a tabindex="{{400 + i}}" (click)="onPage(pageNumber)" (keyup.enter)="onPage(pageNumber)" title="{{ 'bss.admin.selectUserAcc.page.title' | translate }} {{ pageNumber }}">{{ pageNumber }}</a>
              </ng-template>
              <span *ngIf="!last">, </span>
            </ng-container>    
        </div>
      </div>
    </div>
  </div>
</div>



<div class="ontario-row">
  <div class="ontario-column ontario-small-12">
    <button class="ontario-button ontario-button--secondary" tabindex="521"
      title="{{ 'bss.admin.selectUserAcc.back.title' | translate }}" (click)="onBack()">
      {{ 'bss.admin.selectUserAcc.back' | translate }}
    </button>
    <button class="ontario-button ontario-button--primary" tabindex="520"
      title="{{ 'bss.admin.selectUserAcc.next.title' | translate }}" (click)="onSubmit()">
      {{ 'bss.admin.selectUserAcc.next' | translate }}
    </button>
  </div>
</div>

<div class="ontario-row">
  <div class="ontario-column ontario-small-12">
    <button class="ontario-button ontario-button--secondary" tabindex="522"
      title="{{ 'bss.admin.selectUserAcc.newSearch.title' | translate }}" (click)="onNewSearch()">
      {{ 'bss.admin.selectUserAcc.newSearch' | translate }}
    </button>
  </div>

  <dialog class="ontario-progress" #progressDialog>
    <app-progress></app-progress>
  </dialog>